export const MY_SITES_TEXT = 'my sites'
